export enum CalculationMethod {
  VOLUPAL = 'VOLUPAL',

  ADD_FIXED = 'ADD_FIXED',

  ADD_PERCENTAGE = 'ADD_PERCENTAGE',
}
